import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Place } from './place';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';

const _schema = {
    "name": "PLACELINK",
    "fields": [
        { name: "place", type: "objid" },
        { name: "link", type: "string" },
        { name: "url", type: "string" },
        /** Upload payload only (not a DB column); sync sends it as `b64` via Change override. */
        { name: "base64", type: "string", volatile: true },
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "links", name: "place", reason: "place", child: false, class: PlaceType },
    ]
} as const;

const _PlaceLinkClass = CreateObject(_schema);
if (!_PlaceLinkClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

/**
 * External URL row for a place (web, social, menu PDF reference, etc.).
 * Optional `base64` carries a pending file upload for links like `pdfmenu`.
 */
export class PlaceLink extends _PlaceLinkClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    /**
     * Includes `b64` in the sync payload when a pending upload exists.
     * The generic `Change` skips volatile fields; the server expects `b64` only for uploads.
     */
    protected override get Change(): any {
        const _parentChange = super.Change;
        return (async () => {
            let _change: any = _parentChange;
            if (typeof _change === 'function'){
                _change = await _change();
            }
            else {
                _change = await _change;
            }
            if (!_change || typeof _change !== 'object'){
                _change = {};
            }
            const _b64 = this.base64;
            if (_b64){
                _change['b64'] = _b64;
            }
            return _change;
        });
    }

    Copy(store: Array<DataObject> = []): PlaceLink {
        return this._Copy(store) as PlaceLink;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'links' && related instanceof Place){
            if (related === this.place){
                related.AddLink(this);
            }
        }
    }
}
